<template>
  <b-input-group>
    <timer-selector v-model="value" :disabled="!isConnectionOk" />
  </b-input-group>
</template>

<script>
import TimerSelector from '@/components/inputs/TimerSelector.vue';
import BaseControlMixin from '@/components/controls/mixins/BaseControl';

export default {
  name: 'Timer',
  mixins: [
    BaseControlMixin,
  ],
  data() {
    return {
      varsValue: this.vars[0].value,
    };
  },
  computed: {
    value: {
      get() {
        return this.getSingleVar.value / 1000; // convert from milis to secs
      },
      set(value) {
        this.varsValue = value * 1000;
        this.handleControl(this.varsValue);
      },
    },
  },
  components: {
    TimerSelector,
  },
};
</script>

<style scoped>

</style>
